/*
 * Copyright (c) 2022
 * 
 * Created Date: Tuesday, September 20th 2022, 1:52:19 pm
 * Author: Muhammad Fajariansyah Ismail
 * 
 */

import LocalStorageUtils from 'utils/LocalStorage'
import en from 'assets/i18n/en.json'
import i18n from 'i18next'
import id from 'assets/i18n/id.json'
import { initReactI18next } from 'react-i18next'

const resources = {
    en,
    id
}

i18n.use(initReactI18next).init({
    resources,
    lng: LocalStorageUtils.language.get(),
    interpolation: {
        escapeValue: false
    },
    returnObjects: true
})

export default i18n